// extracted by mini-css-extract-plugin
export const container = "BrochureLanguageSelector-module--container--ozUR5";
export const label = "BrochureLanguageSelector-module--label--3407E";
export const input = "BrochureLanguageSelector-module--input--1hYZI";